// ABOUTME: Google Analytics 4 integration for tracking page views and events.
// ABOUTME: Provides functions to initialize GA, log page views, and track custom events.

import ReactGAModule from "react-ga4"
import config from "../config"
import { foreignServicesAllowed } from "./domain"

const ReactGA = (ReactGAModule as { default?: typeof ReactGAModule }).default || ReactGAModule

const isGAEnabled = (): boolean => {
  return config.GA_ENABLED && Boolean(config.GA_TRACKING_ID) && foreignServicesAllowed()
}

export const initGA = (): void => {
  const trackingId = config.GA_TRACKING_ID
  if (isGAEnabled()) {
    ReactGA.initialize(trackingId, {
      gaOptions: {
        app_version: config.BUILD_VERSION,
        environment: config.MODE,
      },
    })

    // Отправляем событие с версией приложения
    ReactGA.event("app_started", {
      category: "Application",
      action: "Started",
      label: config.BUILD_VERSION,
      app_version: config.BUILD_VERSION,
      environment: config.MODE,
    })

    // Устанавливаем глобальные параметры
    ReactGA.gtag("config", trackingId, {
      app_version: config.BUILD_VERSION,
      environment: config.MODE,
    })
  }
}

export const logPageView = (): void => {
  if (isGAEnabled()) {
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname,
      app_version: config.BUILD_VERSION,
    })
  }
}

export const setUserProperties = (userId: string, isPro: boolean, isCoach: boolean): void => {
  if (isGAEnabled()) {
    ReactGA.gtag("set", "user_properties", {
      user_id: userId,
      is_pro: isPro,
      is_coach: isCoach,
      app_version: config.BUILD_VERSION,
    })

    ReactGA.gtag("config", config.GA_TRACKING_ID, {
      user_id: userId,
      app_version: config.BUILD_VERSION,
    })
  }
}

export const trackEvent = (action: string, category: string, label?: string, value?: number): void => {
  if (isGAEnabled()) {
    // Отправляем событие с версией приложения через дополнительные параметры
    ReactGA.gtag("event", action, {
      event_category: category,
      event_label: label,
      value,
      app_version: config.BUILD_VERSION,
      environment: config.MODE,
    })
  }
}
